import { render, staticRenderFns } from "./Autentificacion.vue?vue&type=template&id=5b8f2ec4&scoped=true&"
import script from "./Autentificacion.vue?vue&type=script&lang=js&"
export * from "./Autentificacion.vue?vue&type=script&lang=js&"
import style0 from "./Autentificacion.vue?vue&type=style&index=0&id=5b8f2ec4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8f2ec4",
  null
  
)

export default component.exports